import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { UserNumber } from '@ragu-components/ord-types';

const UserNumberList = React.lazy(async () => import('./UserNumberList'));

export const userNumbersResource: OrdResourceProps = {
  key: Resources.user_numbers,
  name: Resources.user_numbers,
  list: <UserNumberList />,
  options: {},
  recordRepresentation: (record: UserNumber): string => record.number,
};
